import { render, staticRenderFns } from "./AppraisalNumber.vue?vue&type=template&id=2f0db828&scoped=true"
import script from "./AppraisalNumber.vue?vue&type=script&lang=js"
export * from "./AppraisalNumber.vue?vue&type=script&lang=js"
import style0 from "./AppraisalNumber.vue?vue&type=style&index=0&id=2f0db828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0db828",
  null
  
)

export default component.exports